import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSeoForPath } from '@/seo/seoData';
import { applyHomeMeta, applyRouteMeta } from '@/seo/meta';
import { applyJsonLd } from '@/seo/jsonLd';

export default function SeoManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === '/') {
      applyHomeMeta();
      applyJsonLd('/');
      return;
    }

    const seo = getSeoForPath(pathname);
    if (seo) {
      applyRouteMeta(seo);
      applyJsonLd(pathname, seo);
    } else {
      applyHomeMeta();
      applyJsonLd(pathname);
    }
  }, [pathname]);

  return null;
}